import { render } from "./RecognizeUserMetaMode.vue?vue&type=template&id=6584df14&scoped=true"
import script from "./RecognizeUserMetaMode.vue?vue&type=script&lang=js"
export * from "./RecognizeUserMetaMode.vue?vue&type=script&lang=js"

import "./RecognizeUserMetaMode.vue?vue&type=style&index=0&id=6584df14&lang=scss&scoped=true"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6584df14"]])

export default __exports__